/** App bar shadow, mobile drawer, and homepage scroll-spy. */

export function initAppBar(): void {
  const appbar = document.getElementById('appbar');
  if (!appbar) return;
  addEventListener(
    'scroll',
    () => appbar.classList.toggle('scrolled', scrollY > 8),
    { passive: true },
  );
}

export function initDrawer(): void {
  const drawer = document.getElementById('drawer');
  const scrim = document.getElementById('scrim');
  const menuBtn = document.getElementById('menu-btn');
  if (!drawer || !scrim || !menuBtn) return;

  const open = (isOpen: boolean): void => {
    drawer.classList.toggle('open', isOpen);
    scrim.classList.toggle('open', isOpen);
    menuBtn.setAttribute('aria-expanded', String(isOpen));
  };

  menuBtn.addEventListener('click', () => open(!drawer.classList.contains('open')));
  scrim.addEventListener('click', () => open(false));
  drawer.querySelectorAll('a, md-list-item').forEach((item) => {
    item.addEventListener('click', () => open(false));
  });
  addEventListener('keydown', (event) => {
    if (event.key === 'Escape') open(false);
  });
}

/** Must stay in document order — the probe picks the last section above it. */
const SECTION_IDS = [
  'profile',
  'research',
  'news',
  'publications',
  'projects',
  'awards',
  'teaching',
  'media',
] as const;

export function initScrollSpy(): void {
  const links = [...document.querySelectorAll<HTMLElement>('[data-link]')];
  const sections = SECTION_IDS.map((id) => document.getElementById(id)).filter(
    (el): el is HTMLElement => el !== null,
  );
  if (!links.length || !sections.length) return;

  const currentId = (): string | undefined => {
    const probe = scrollY + Math.min(innerHeight * 0.35, 260);
    let current = sections[0];
    for (const section of sections) {
      if (section.offsetTop <= probe) current = section;
    }
    return current?.id;
  };

  let queued = false;
  const update = (): void => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => {
      queued = false;
      const id = currentId();
      for (const link of links) {
        const href = link.getAttribute('href') ?? '';
        link.classList.toggle('active', id !== undefined && href.includes(`#${id}`));
      }
    });
  };

  addEventListener('scroll', update, { passive: true });
  addEventListener('resize', update);
  addEventListener('hashchange', () => setTimeout(update, 0));
  update();
}
